module.exports = __webpack_public_path__ + "static/media/phone.9c8f50a3.svg";